/* Reusable promo landing page — assets/landing-page.js */
(function () {
  var root = document.getElementById('landing-page');
  if (!root || root.getAttribute('data-lp-initialized') === 'true') return;
  root.setAttribute('data-lp-initialized', 'true');

  var shopRoot =
    window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root
      : '/';

  /* ── Scroll progress bar ─────────────────────────────── */
  var bar = document.getElementById('lp-progress');

  function progress() {
    if (!bar) return;

    var de = document.scrollingElement || document.documentElement;
    var max = de.scrollHeight - de.clientHeight;
    bar.style.width = (max > 0 ? (de.scrollTop / max) * 100 : 0) + '%';
  }

  document.addEventListener('scroll', progress, { passive: true });
  window.addEventListener('resize', progress, { passive: true });
  progress();

  /* ── Hero parallax ───────────────────────────────────── */
  var hero = document.getElementById('top');
  var parallaxCopy = root.querySelector('[data-lp-parallax-copy]');
  var parallaxCutout = root.querySelector('[data-lp-parallax-cutout]');
  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;
  var parallaxFrame = null;

  function resetParallax() {
    if (parallaxCopy) {
      parallaxCopy.style.setProperty('--lp-parallax-y', '0px');
    }

    if (parallaxCutout) {
      parallaxCutout.style.setProperty('--lp-parallax-y', '0px');
    }
  }

  function updateParallax() {
    parallaxFrame = null;

    if (!hero || (!parallaxCopy && !parallaxCutout)) return;

    if (
      (reduceMotion && reduceMotion.matches) ||
      window.innerWidth <= 760
    ) {
      resetParallax();
      return;
    }

    var rect = hero.getBoundingClientRect();

    if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

    var distance = Math.max(0, -rect.top);

    if (parallaxCopy) {
      parallaxCopy.style.setProperty(
        '--lp-parallax-y',
        (distance * -0.075).toFixed(2) + 'px'
      );
    }

    if (parallaxCutout) {
      parallaxCutout.style.setProperty(
        '--lp-parallax-y',
        (distance * -0.145).toFixed(2) + 'px'
      );
    }
  }

  function requestParallax() {
    if (parallaxFrame !== null) return;
    parallaxFrame = window.requestAnimationFrame(updateParallax);
  }

  document.addEventListener('scroll', requestParallax, { passive: true });
  window.addEventListener('resize', requestParallax, { passive: true });

  if (reduceMotion && reduceMotion.addEventListener) {
    reduceMotion.addEventListener('change', requestParallax);
  }

  requestParallax();

  /* ── Header condense ─────────────────────────────────── */
  var header = document.getElementById('lp-header');
  var sentinel = document.getElementById('lp-sentinel');

  if (header && sentinel && window.IntersectionObserver) {
    new IntersectionObserver(
      function (entries) {
        header.setAttribute(
          'data-scrolled',
          entries[0].isIntersecting ? 'false' : 'true'
        );
      },
      { threshold: 0 }
    ).observe(sentinel);
  }

  /* ── Mobile menu ─────────────────────────────────────── */
  var menu = document.getElementById('lp-mobile-menu');
  var menuBtn = document.getElementById('lp-menu-btn');

  function setMenu(open) {
    if (!menu || !menuBtn) return;

    menu.setAttribute('data-open', open ? 'true' : 'false');
    menu.style.transform = open ? 'translateY(0)' : 'translateY(-102%)';
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  if (menuBtn) {
    menuBtn.addEventListener('click', function () {
      setMenu(menu.getAttribute('data-open') !== 'true');
    });
  }

  if (menu) {
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) {
        setMenu(false);
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (
      event.key === 'Escape' &&
      menu &&
      menu.getAttribute('data-open') === 'true'
    ) {
      setMenu(false);

      if (menuBtn) {
        menuBtn.focus();
      }
    }
  });

  /* ── Copy discount code ──────────────────────────────── */
  function legacyCopy(text) {
    var input = document.createElement('textarea');

    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';

    document.body.appendChild(input);
    input.select();

    try {
      document.execCommand('copy');
    } catch (error) {}

    document.body.removeChild(input);
  }

  root.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-copy-code]');

    if (!btn || !root.contains(btn)) return;

    var code = root.getAttribute('data-promo-code') || '';

    if (!code) return;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).catch(function () {
        legacyCopy(code);
      });
    } else {
      legacyCopy(code);
    }

    var label = btn.querySelector('[data-copy-label]');

    if (label) {
      label.textContent = 'copied';

      window.setTimeout(function () {
        label.textContent = 'tap to copy';
      }, 1800);
    }
  });

  /* ── AJAX add to cart (falls back to normal POST) ───── */
  var count = document.getElementById('lp-cart-count');

  root.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-lp-add]');

    if (!form || !root.contains(form) || !window.fetch) return;

    var idInput = form.querySelector('[name="id"]');

    if (!idInput || !idInput.value) return;

    event.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var original = btn ? btn.textContent.trim() : '';

    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }

    fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(idInput.value),
            quantity: 1
          }
        ]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        return response.json();
      })
      .then(function () {
        return fetch(shopRoot + 'cart.js', {
          headers: {
            Accept: 'application/json'
          }
        });
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart refresh failed');
        }

        return response.json();
      })
      .then(function (cart) {
        if (count) {
          count.textContent = cart.item_count;
        }

        if (btn) {
          btn.textContent = 'Added ✓';
        }

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
              cart: cart
            }
          })
        );
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        window.setTimeout(function () {
          if (btn) {
            btn.disabled = false;
            btn.textContent = original || 'Add to Cart';
          }
        }, 1400);
      });
  });
})();